export enum SendOptions {
    SEND_NOW = "Now",
    SEND_LATER = "A later time",
}

export const DefaultStaggeredDays = 2;
